export const firebaseConfig = {
  apiKey: 'AIzaSyABE2fewljQ-uakaX13VmQ5DJyPhTGBwXM',
  authDomain: 'heramagroup-39605.firebaseapp.com',
  projectId: 'heramagroup-39605',
  storageBucket: 'heramagroup-39605.appspot.com',
  messagingSenderId: '1013745666407',
  appId: '1:1013745666407:web:9228828601740ebeb247c2',
  measurementId: 'G-YNP3C533HB'
}
